import { gql, useMutation } from '@apollo/client';
import {
  Loyalty_SubmitEnrollmentFormMutation,
  Loyalty_SubmitEnrollmentFormMutationVariables,
} from '@/types';
import { useCallback } from 'react';

export const SUBMIT_LOYALTY_ENROLLMENT_FORM_MUTATION = gql`
  mutation Loyalty_SubmitEnrollmentForm(
    $supplierLoyaltyProgramRestaurantUUID: uuid!
    $responses: [LoyaltyEnrollmentFormResponseInput!]!
  ) {
    submitLoyaltyEnrollmentForm(
      supplier_loyalty_program_restaurant_id: $supplierLoyaltyProgramRestaurantUUID
      responses: $responses
    ) {
      alert_level
      alert_message
      error_code
      supplier_loyalty_program_restaurant_id
    }
  }
`;

export const useSubmitLoyaltyEnrollmentForm = () => {
  const [submit, { loading: isSubmitting }] = useMutation<
    Loyalty_SubmitEnrollmentFormMutation,
    Loyalty_SubmitEnrollmentFormMutationVariables
  >(SUBMIT_LOYALTY_ENROLLMENT_FORM_MUTATION, {
    fetchPolicy: 'no-cache',
  });

  const submitLoyaltyEnrollmentForm = useCallback(
    async (params: {
      responses: { key: string; value: string }[];
      supplierLoyaltyProgramRestaurantUUID: string;
    }) => {
      const { data } = await submit({
        variables: {
          responses: params.responses,
          supplierLoyaltyProgramRestaurantUUID:
            params.supplierLoyaltyProgramRestaurantUUID,
        },
      });

      return data?.submitLoyaltyEnrollmentForm ?? null;
    },
    [submit],
  );

  return { isSubmitting, submitLoyaltyEnrollmentForm };
};
